import { render } from "./reset-password-temporary.vue?vue&type=template&id=09f66782"
import script from "./reset-password-temporary.vue?vue&type=script&lang=js"
export * from "./reset-password-temporary.vue?vue&type=script&lang=js"

import "./reset-password-temporary.vue?vue&type=style&index=0&id=09f66782&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__